import { OrderFeature } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

// eslint-disable-next-line aloft/prefer-sound-ui-button
import { CraftsmanAddCompButtons } from '../../../components/CraftsmanAddCompButtons.tsx';
import { Feature } from '../../../redux/constants.ts';
import { setOrderFeatures } from '../../../redux/features/orderSlice.ts';
import { selectOrderFeatures } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.ts';
import { AddFeaturesPopover } from '../../analysis/modals/objectiveEdit/AddFeaturesPopover.tsx';
// eslint-disable-next-line aloft/prefer-sound-ui-button
import { VerifyAllFeaturesButton } from './VerifyAllFeaturesButton.tsx';
// eslint-disable-next-line aloft/prefer-sound-ui-button
import { ViewZillowListingButton } from './ViewZillowListingButton.tsx';

export const FeatureGridToolbar = () => {
  const dispatch = useAppDispatch();
  const orderFeatures = useAppSelector(selectOrderFeatures);

  const isFeatureGrid = window.location.pathname.includes('features');

  return (
    <Flex
      className="toolbar-container"
      justifyContent="space-between"
      flexShrink={1}
      flexWrap="wrap"
      paddingTop="0.5rem"
      paddingX="1.5rem"
      backgroundColor="surface1"
    >
      <Flex gap="1.5rem" alignItems="flex-end">
        <CraftsmanAddCompButtons />
        {isFeatureGrid && (
          <AddFeaturesPopover
            buttonProps={{ variant: 'secondary', size: 'sm' }}
            label="Add Feature"
            features={orderFeatures}
            handleAddFeature={(feature: Feature) => {
              dispatch(setOrderFeatures([...orderFeatures, feature as OrderFeature]));
            }}
          />
        )}
        <ViewZillowListingButton />
      </Flex>
      <Flex alignItems="flex-end">
        <VerifyAllFeaturesButton />
      </Flex>
    </Flex>
  );
};
